var _Rect, _Path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Rect, Path } from "react-native-svg";
function SvgAppPassengerIndicator(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Rect || (_Rect = /*#__PURE__*/React.createElement(Rect, {
    width: 20,
    height: 20,
    rx: 8,
    fill: "#F900B2"
  })), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M7.44 14.727H5.612l3.329-9.454h2.114l3.333 9.454H12.56l-2.525-7.515H9.96l-2.52 7.515zm.06-3.707h4.986v1.376H7.5V11.02z",
    fill: "#fff"
  })));
}
export default SvgAppPassengerIndicator;